import React, { FC, HTMLAttributes, ReactNode } from 'react';
import { WithAnalytics } from 'ia-react-core/~/interfaces/WithAnalytics';
import { StyledButton } from './MainHeaderButton.styles';

export interface MainHeaderButtonProps extends WithAnalytics, HTMLAttributes<HTMLButtonElement> {
  children?: ReactNode;
}

const MainHeaderButton: FC<MainHeaderButtonProps> = (props) => (
  <StyledButton
    data-testid="MainHeaderButton"
    {...props}
  />
);

export default MainHeaderButton;
